var crMonitor = (function() {
	return {

		start: function(label) {
			if (E !== 1 && typeof console !== "undefined" && typeof console.time !== "undefined") {
				console.time(label);
			}
		},

		end: function(label) {
			if (E !== 1 && typeof console !== "undefined" && typeof console.timeEnd !== "undefined") {
				console.timeEnd(label);
			}
		}
	};
})();
